
<template>
  <div class="box" ref="box" @touchend="getPlayTimeLength">
    <iframe class="size-helper" ref="sizeHelper" @resize="resizeVideo"></iframe>
    <div class="tips" v-if="noWifiTips">
      <i class="icon icon-play" @click="noWifiPlay"></i>
      <p>{{ getDict(10) }}</p>
    </div>
    <div
      ref="playerContainer"
      :id="`player-container-${id}`"
      class="player-container"
    ></div>
  </div>
</template>

<script>
// https://developers.google.com/youtube/iframe_api_reference

import { bus, getDict, axios, config } from "../common";
import { invokeNative } from "../common";
import { listen, unlisten } from "../common/invokeNative";
import { mapState, mapGetters } from "vuex";

let isYoutubeAPIReady = false;
let cannotUseYoutube = false;

const $script = document.createElement("script");
$script.src = "https://www.youtube.com/iframe_api";

window.onYouTubeIframeAPIReady = () => {
  isYoutubeAPIReady = true;
  bus.$emit("youtubeAPIReady");
};

document.body.appendChild($script);
//判断youtube是否能加载
$script.onerror = () => {
  cannotUseYoutube = true;
  bus.$emit("cannotUseYoutubeAPI");
};
$script.onload = () => {
  setTimeout(() => {
    if (!window.YT || !window.YTConfig) {
      cannotUseYoutube = true;
      bus.$emit("cannotUseYoutubeAPI");
    }
  }, 10);
};

let id = 1;

export default {
  props: {
    platform: String,
    videoId: String,
  },
  data() {
    return {
      id: id++,
      playerObj: null,
      gameStopPlayer: false,
      noWifiTips: false,
      playing: false,
      hasInit: false,
      canUseYoutube: true,

      playFromStartTime: 0,
    };
  },
  computed: {
    ...mapState(["goingTime"]),
  },
  watch: {
    videoId(newVal, oldVal) {
      console.log("[player] videoId changed:", oldVal, "->", newVal);
      // 若首次拿到 videoId 时 player 尚未初始化（YT API 已就绪但当时没 videoId 而被跳过），此时补一次初始化
      if (!this.playerObj && this.videoId) {
        this.tryInitPlayer();
        this.logView();
        this.playFromStartTime = 0;
        return;
      }
      let changeVideo = () => {
        if (this._destroyed) {
          return;
        }
        if (this.playerObj && this.playerObj.cueVideoById) {
          this.playerObj.cueVideoById({
            videoId: this.videoId,
          });
          if (!this.noWifiTips && this.videoId) {
            this.playerObj.playVideo();
          }
        } else {
          if (this.hasInit) {
            this._changeVideoTimer = setTimeout(() => {
              changeVideo();
            }, 100);
          }
        }
      };
      changeVideo();
      this.logView();
      this.playFromStartTime = 0;
    },
    playerObj() {
      this.getPlayTimeLength();
    },
    playFromStartTime() {
      bus.$emit("videoPlayTimeChange", this.playFromStartTime);
    },
    goingTime() {
      this.timer();
    },
  },
  methods: {
    getDict,
    timer() {
      this.getPlayTimeLength();
    },
    getPlayTimeLength() {
      if (this.playerObj && this.playerObj.getCurrentTime) {
        let time = this.playerObj.getCurrentTime();
        this.playFromStartTime = Math.floor(time * 1000);
      }
    },
    playerVideo() {
      let play = () => {
        if (this._destroyed) {
          return;
        }
        if (this.playerObj && this.playerObj.playVideo) {
          this.playerObj.playVideo();
        } else {
          if (this.hasInit) {
            this._playRetryTimer = setTimeout(() => {
              play();
            }, 100);
          }
        }
      };
      play();
    },
    noWifiPlay() {
      this.noWifiTips = false;
      this.playerVideo();
    },
    onGamePause() {
      if (this.playing) {
        this.gameStopPlayer = true;
      }
      if (this.playerObj && this.playerObj.pauseVideo) {
        this.playerObj.pauseVideo();
      }
    },
    onGameResume() {
      if (this.gameStopPlayer) {
        this.gameStopPlayer = false;
        this.playerVideo();
      }
    },
    initPlayer() {
      const $player = this.$refs.playerContainer;
      if (!$player) {
        return;
      }
      this.hasInit = true;
      const opts = {
        width: $player.clientWidth,
        height: $player.clientHeight,
        playerVars: {
          playsinline: 1,
          autoplay: 1,
          fs: 0,
          rel: 0,
        },
        events: {
          // 'onReady': onPlayerReady,
          // 'onPlaybackQualityChange': onPlayerPlaybackQualityChange,
          onStateChange: (res) => {
            let status = res.data;
            console.log("youtubeStateChange", status);

            switch (status) {
              case YT.PlayerState.PLAYING:
                this.stopMusic();
                this.playing = true;
                break;
              case YT.PlayerState.PAUSED:
                this.playing = false;
                if (!this.gameStopPlayer) {
                  //以为游戏到后台而暂停则不需要播放游戏音乐
                  this.startMusic();
                }

                break;
            }
          },
          onError: (e) => {
            console.error("[player] YT onError:", e && e.data);
          },
        },
      };
      // 仅在有 videoId 时传入，避免 YT 抛 "Invalid video id"
      if (this.videoId) {
        opts.videoId = this.videoId;
      }
      this.playerObj = new YT.Player(`player-container-${this.id}`, opts);

      listen("onGamePause", this.onGamePause);
      listen("onGameResume", this.onGameResume);
      this.$emit("playerInited");
    },
    tryInitPlayer() {
      if (this.playerObj) {
        return;
      }
      if (!this.videoId) {
        // 等 videoId 就绪后由 watcher 触发
        return;
      }
      if (!window.YT || !window.YT.Player) {
        // 等 YT API ready
        return;
      }
      this.initPlayer();
    },
    stopMusic() {
      console.log("stopMusic");
      invokeNative(
        "stopGameMusic",
        {},
        (res) => {
          // 执行成功
        },
        (res) => {
          //执行失败
        }
      );
    },
    startMusic() {
      console.log("startMusic");
      invokeNative(
        "playGameMusic",
        {},
        (res) => {
          // 执行成功
        },
        (res) => {
          //执行失败
        }
      );
    },
    logView() {
      // console.log(123)
      if (config.videoPlayCount) {
        if (config.videoPlayCount.url) {
          axios
            .get(config.videoPlayCount.url + "/uslog", {
              params: {
                body: JSON.stringify({
                  videoID: this.videoId,
                }),
                head: "unisdk_cattle_b",
              },
            })
            .then((res) => {})
            .catch((error) => {});
        }
      } else {
        config.afterInit(() => {
          this.logView();
        });
      }
    },
    resizeVideo() {
      let $player = this.$refs.box;
      if (!$player || !this.playerObj || !this.playerObj.setSize) {
        return;
      }
      this.playerObj.setSize($player.clientWidth, $player.clientHeight);
    },
  },
  mounted() {
    try {
      this.$refs.sizeHelper.contentWindow.addEventListener(
        "resize",
        this.resizeVideo
      );
    } catch (e) {}

    if (true || this.platform === "youtube") {
      if (!cannotUseYoutube) {
        bus.$once("cannotUseYoutubeAPI", this._onCannotUseYoutube);
      } else {
        this.canUseYoutube = false;
      }
      if (!isYoutubeAPIReady) {
        bus.$once("youtubeAPIReady", this.tryInitPlayer);
      } else {
        this.tryInitPlayer();
      }
    }
    this.$busOn("setRemUnit", () => {
      //$busOn
      // console.log(123123)
      let $player = this.$refs.box;
      if (!$player) {
        return;
      }
      // this.playerObj.setSize($player.clientWidth,$player.clientHeight);
    });
    this.getPlayTimeLength();
  },
  created() {
    // setTimeout(()=>{this.playerVideo()},2000)

    this._onPlayerInitedPlay = () => {
      this.playerVideo();
    };
    this._onCannotUseYoutube = () => {
      this.canUseYoutube = false;
    };
    const handleNetwork = (isWifi) => {
      this.noWifiTips = !isWifi;
      if (isWifi) {
        if (this.hasInit) {
          this.playerVideo();
        } else {
          // 实例事件，与 initPlayer 中 this.$emit("playerInited") 配对，避免跨组件干扰
          this.$once("playerInited", this._onPlayerInitedPlay);
        }
      }
    };
    invokeNative(
      "getNetworkType",
      {},
      (res) => {
        // {"errno":0,"message":"","data":{"result":"wifi"}}
        if (res.errno === 0) {
          const networkType = res.data && res.data.result;
          handleNetwork(networkType === "wifi");
        } else {
          handleNetwork(false);
        }
      },
      () => {
        //执行失败：保守处理，按非 wifi 展示提示，避免误耗流量
        handleNetwork(false);
      }
    );
    if (this.videoId) {
      this.logView();
    }
  },
  beforeDestroy() {
    this._destroyed = true;
    if (this._playRetryTimer) {
      clearTimeout(this._playRetryTimer);
      this._playRetryTimer = null;
    }
    if (this._changeVideoTimer) {
      clearTimeout(this._changeVideoTimer);
      this._changeVideoTimer = null;
    }
    bus.$off("youtubeAPIReady", this.tryInitPlayer);
    if (this._onCannotUseYoutube) {
      bus.$off("cannotUseYoutubeAPI", this._onCannotUseYoutube);
    }
    unlisten("onGamePause", this.onGamePause);
    unlisten("onGameResume", this.onGameResume);
    if (this.playerObj && typeof this.playerObj.destroy === "function") {
      try {
        this.playerObj.destroy();
      } catch (e) {
        console.warn("[player] destroy failed:", e);
      }
      this.playerObj = null;
    }
    try {
      if (this.$refs.sizeHelper && this.$refs.sizeHelper.contentWindow) {
        this.$refs.sizeHelper.contentWindow.removeEventListener(
          "resize",
          this.resizeVideo
        );
      }
    } catch (e) {}
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  position: relative;
  // height: 100%;

  .size-helper {
    position: absolute;
    padding: 0;
    margin: 0;
    border: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  .tips {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #232324;
    align-items: center;

    .icon-play {
      $width: 0.9rem;
      $height: $width/67 * 54;
      width: $width;
      height: $height;
    }
    p {
      margin-top: 0.3rem;
      color: #818181;
      font-size: 0.3rem;
    }
  }
}
.player-container {
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
</style>
